module.exports = __webpack_public_path__ + "img/kp3.42cd5372.png";